let toastTimeout = null;

export function showToast(message, type = "success") {
  // Remove existing toast
  const existing = document.getElementById("snap-toast");
  if (existing) existing.remove();

  const toast = document.createElement("div");
  toast.id = "snap-toast";
  toast.textContent = message;

  toast.style.position = "fixed";
  toast.style.bottom = "24px";
  toast.style.left = "50%";
  toast.style.transform = "translateX(-50%)";
  toast.style.padding = "10px 16px";
  toast.style.borderRadius = "10px";
  toast.style.fontWeight = "700";
  toast.style.zIndex = "9999";
  toast.style.color = "#000";
  toast.style.background =
    type === "success"
      ? "linear-gradient(90deg, #FFD700, #FFA500)"
      : "#ff4d4f";
  toast.style.boxShadow = "0 6px 20px rgba(0,0,0,0.35)";
  toast.style.opacity = "0";
  toast.style.transition = "opacity 0.25s ease";

  document.body.appendChild(toast);

  // fade in
  requestAnimationFrame(() => {
    toast.style.opacity = "1";
  });

  clearTimeout(toastTimeout);
  toastTimeout = setTimeout(() => {
    toast.style.opacity = "0";
    setTimeout(() => toast.remove(), 250);
  }, 2000);
}
